import { ReactNode } from 'react';
import { useLang } from 'hooks/lang';

import { issueStatuses, loaders } from 'entities';

import { Box, Row, Skeleton } from 'components/Blocks';
import { CircleXIcon, DoubleCheckIcon, IssueIcon } from 'components/Icons';

import { useIssuesHome } from './context';
import { cn } from 'styles';

const iconMapping: Record<string, ReactNode> = {
  [issueStatuses.active.code]: <IssueIcon size={22} color="#014272" />,

  [issueStatuses.resolved.code]: <DoubleCheckIcon size={22} color="#19c29b" />,

  [issueStatuses.closed.code]: <CircleXIcon size={22} color="#e47474" />,
};

export function IssueStatuses() {
  const { t } = useLang();

  const { dispatch, state } = useIssuesHome();

  const { data, errorOrLoading } = loaders.projects.getIssueCounts.use({
    defaultValue: {},

    realTimeSubscription: {
      type: 'ISSUE_COUNTS',

      onMessage: ({ counts }) => counts,
    },
  });

  const statuses = Object.values(issueStatuses).map(({ getLabel, code }) => ({
    getLabel,
    status: code,
    count: data[code] ?? 0,
    icon: iconMapping[code],
  }));

  return (
    <div className="grid grid-cols-3 gap-4 phone:grid-cols-2">
      {statuses.map(({ getLabel, count, icon: statusIcon, status }) =>
        errorOrLoading ? (
          <Skeleton key={`skeleton-${status}`} height={130} />
        ) : (
          <div
            key={status}
            onClick={() => dispatch({ status })}
            className={cn(
              'flex h-[130px] flex-col justify-center gap-4 rounded-md border border-border p-4 transition-colors hover:bg-hover',
              status === state.status ? 'outline outline-2 outline-primary' : 'cursor-pointer',
              'phone:p-2 phone:last-of-type:col-span-2',
            )}
          >
            <Row justifyContent="space-between" gap="2">
              <p className="font-medium">{getLabel(t)}</p>

              <Box border="rounded" className="border border-border p-2">
                {statusIcon}
              </Box>
            </Row>

            <span className="text-[34px] font-medium text-[#9e9e9e]">{count}</span>
          </div>
        ),
      )}
    </div>
  );
}

export default IssueStatuses;
